import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFooter,{attrs:{"padless":""}},[_c(VRow,{attrs:{"justify":"center","no-gutters":""}},[_c('a',{attrs:{"href":"https://www.inaccess.com/terms-of-use/","target":"_blank"}},[_vm._v("Terms of Use / Privacy Policy")]),_vm._v("   |   "),_c('a',{attrs:{"href":"https://www.inaccess.com/cookies-policy/","target":"_blank"}},[_vm._v("Website Cookie Policy")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }